<template>
  <div class="content homepage">
    <div class="row">
      <div class="columns small-12 small-centered header-margin">
        <div class="actionheader">
          <h1>
            <strong>Review your Order</strong>
          </h1>
        </div>
        <div class="dark-text">
          <p class="text-center">Review your order for accuracy. Once you are satisfied, please review and accept terms, and press Order Now.</p>
        </div>
      </div>
    </div>
    <form @submit.prevent="validateBeforeReview">
      <original-about-info-review v-if="program.programType == 'ECPStandard'" :sampleobject='sampleobject'></original-about-info-review>
      <about-info-review v-if="program.programType == 'ECPChoice'" :program="program" :sampleobject='sampleobject'></about-info-review>
      <university-about-info-review v-if="program.programType == 'University'" :sampleobject='sampleobject'></university-about-info-review>
      <employee-about-info-review v-if="program.programType == 'Employee'" :sampleobject='sampleobject'></employee-about-info-review>
      <ship-info-review v-if="program.programType == 'ECPStandard' || program.programType == 'ECPChoice'" :sampleobject='sampleobject'></ship-info-review>
      <rx-info-review :sampleobject='sampleobject' :choices='choices'></rx-info-review>
      <frame-info-review :sampleobject='sampleobject' :program="program"></frame-info-review>
      <accept-terms :sampleobject='sampleobject' :terms-content='termsContent'></accept-terms>

      <div class="row">
        <div class="columns small-6 medium-10 text-right 1p">
          <router-link class="btn btn-submit btn-order-lenses" :to="{ name: 'order_input', params: { userId: sampleobject.couponCode }}">Go Back</router-link>
        </div>
        <div class="columns small-6 medium-2  text-right 1p">
          <input type="submit" class="btn btn-submit btn-order-lenses" value="Order Now"> </div>
      </div>
    </form>
  </div>
</template>
<script>
import RxInfoReview from "@/components/order/RxInfoReview";
import ShipInfoReview from "@/components/order/ShipInfoReview";
import FrameInfoReview from "@/components/order/frame/FrameInfoReview";
import AboutInfoReview from "@/components/order/AboutInfoReview";
import OriginalAboutInfoReview from "@/components/order/OriginalAboutInfoReview";

import UniversityAboutInfoReview from "@/components/order/UniversityAboutInfoReview";
import EmployeeAboutInfoReview from "@/components/order/EmployeeAboutInfoReview";
import AcceptTerms from "@/components/order/AcceptTerms";
import Vue from "vue";

export default {
  props: ["sampleobject", "choices", "program"],
  components: {
    AcceptTerms,
    RxInfoReview,
    ShipInfoReview,
    FrameInfoReview,
    AboutInfoReview,
    OriginalAboutInfoReview,
    UniversityAboutInfoReview,
    EmployeeAboutInfoReview
  },
  methods: {
    validateBeforeReview() {
      this.$validator
        .validateAll()
        .then(result => {
          if (!result) {
            window.scroll(0, 0);
            return;
          }
          this.$router.push({
            name: "order_process",
            params: { sampleobject: this.sampleobject }
          });
        })
        .catch(err => {});
    }
  },
  created() {
    if (!this.sampleobject || !this.sampleobject.resph) {
      this.$router.push("/");
    }
    this.termsContent = this.$parent.termsContent;
  }
};
</script>
<style>
.btn-order-lenses {
  margin: 15px 0;
}
</style>
